import React from "react"
import styled from "styled-components"
import { theme } from "@/common/Mixin"

export interface HeadingProps {
  content: string
  content2?: string
  primary?: boolean
  themeNew?: any
  shadow?: boolean
  center?: boolean
  big?: boolean
  type?: string
  className?: string
  style?: React.CSSProperties
  [x: string]: any
}

const Heading = ({
  content,
  content2,
  primary, //primary 文字漸層色
  themeNew, //這邊可以指定primary & secondary 顏色 要用 {primary,secondary} 兩個值傳進來
  shadow,
  center,
  big,
  type,
  className,
  style,
  ...props
}: HeadingProps) => {
  const Class = {
    Heading: `${shadow ? "shadow" : ""} ${primary ? "primary" : ""} ${
      center ? "center" : ""
    } ${big ? "big" : ""} ${type ? type : ""} ${className ? className : ""}`
  }

  return (
    <HeadingWrapper
      style={style}
      className={Class.Heading}
      themeNew={themeNew}
      {...props}
    >
      <span>
        {content}
        {content2 && <span>{content2}</span>}
      </span>
    </HeadingWrapper>
  )
}

export default Heading

interface HeadingWrapperProps {
  themeNew?: any
}

const HeadingWrapper = styled.h2<HeadingWrapperProps>`
  display: flex;
  flex-wrap: wrap;
  margin: 0px;
  @media (max-width: 768px) {
    span {
      /* width: 100%; */
      /* display: block; */
    }
    justify-content: center;
    text-align: center;
  }
  &.center {
    justify-content: center;
    align-items: center;
    span {
      text-align: center;
    }
  }
  &.shadow {
    span {
      text-shadow:
        0 0 20px
          ${({ themeNew }) =>
            themeNew ? themeNew.primary + "44" : theme.color.primaryLight},
        0 0 60px
          ${({ themeNew }) =>
            themeNew ? themeNew.secondary + "44" : theme.color.textShadowLight};
      @media (max-width: 768px) {
        text-shadow:
          0 0 10px
            ${({ themeNew }) =>
              themeNew ? themeNew.primary + "44" : theme.color.primaryLight},
          0 0 30px
            ${({ themeNew }) =>
              themeNew
                ? themeNew.secondary + "44"
                : theme.color.textShadowLight};
      }
      @media (max-width: 640px) {
        text-shadow:
          0 0 5px
            ${({ themeNew }) =>
              themeNew ? themeNew.primary + "44" : theme.color.primaryLight},
          0 0 10px
            ${({ themeNew }) =>
              themeNew
                ? themeNew.secondary + "44"
                : theme.color.textShadowLight};
      }
    }
  }

  &.primary {
    > span {
      background: linear-gradient(
        130deg,
        ${({ themeNew }) => (themeNew ? themeNew.primary : theme.color.title)},
        ${({ themeNew }) =>
          themeNew ? themeNew.secondary : theme.color.titleHighlight}
      );
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
  &.big {
    span {
      font-size: var(--h1);
    }
  }
`
